(function () {

  const raw =
    localStorage.getItem(
      "mh_calculation_request"
    );


  if (!raw) {
    console.log(
      "MH: Keine Kalkulationsdaten vorhanden."
    );
    return;
  }


  let calc;


  try {
    calc = JSON.parse(raw);
  } catch (error) {
    console.error(
      "MH: Kalkulationsdaten ungültig.",
      error
    );
    return;
  }


  const payload = {

    type:
      "MH_CALCULATION_DATA",

    values: {

      /* Sichtbares PLZ-Feld im Hulk-Formular. */
      plz:
        calc.plz ||
        calc.postalCode ||
        "",

      projektart:
        calc.project || "",

      "meister-deal":
        calc.deal || "",

      projektzusammenfassung:
        String(calc.summary || "")
          .replace(/\s*\|\s*/g, "\n"),

      nettopreis:
        calc.net || "",

      mehrwertsteuer:
        calc.vat || "",

      gesamtpreis_brutto:
        calc.gross || "",

      preisstatus:
        calc.priceStatus || "",

      arbeitsbeginn:
        calc.start || "",

      fertigstellung:
        calc.finish || ""

    }

  };


  function sendToHulk() {

    const frame =
      document.getElementById(
        "frame_FcWO9WyO_Nl7D_dJxC4jtg"
      );


    if (
      !frame ||
      !frame.contentWindow
    ) {
      return false;
    }


    frame.contentWindow.postMessage(
      payload,
      "https://formbuilder.hulkapps.com"
    );


    console.log(
      "MH: Kalkulationsdaten inklusive PLZ an Hulk gesendet."
    );


    return true;

  }


  let attempts = 0;


  const timer =
    setInterval(
      function () {

        attempts++;


        if (
          sendToHulk() ||
          attempts >= 40
        ) {
          clearInterval(timer);
        }

      },
      500
    );


  document.addEventListener(
    "load",
    function (event) {

      if (
        event.target &&
        event.target.id ===
          "frame_FcWO9WyO_Nl7D_dJxC4jtg"
      ) {
        setTimeout(
          sendToHulk,
          500
        );
      }

    },
    true
  );

})();
